<template>
  <main class="project-page page-padding page-sidebar">
    <transition name="fade">
      <div class="project-edit"
           :class="{'project-body_open': navigatorOpen, 'fullscreen-body': !activeZoom}">
        <projects-navigator :project-edit="true"
                            :class="{'zoomed-navigator': activeZoom}"></projects-navigator>

        <projectHeader />

        <projectEditBody />

      </div>
    </transition>

    <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

    </p>
  </main>
</template>

<script>
  import {projectPageMixin} from "../../mixins/projects/projectPageMixin";
  import {mapMutations} from 'vuex'

  import projectHeader from '../../components/Pages/Project/projectHeader'
  import projectEditBody from '../../components/Pages/Project/projectEditBody'

  export default {
    name: "projectEdit",
    mixins: [projectPageMixin],
    components: {projectHeader, projectEditBody},
    methods: {
      ...mapMutations({
        showAddThingPopup: 'popups/addThing/SET_SHOW',
        setType: 'popups/addThing/SET_TYPE',
      }),
      showAdd(param) {
        this.showOverlay(true);
        this.showAddThingPopup(true);

        switch (param) {
          case ('multi'): {this.setType('multi')};
            break;
          case('group'): {this.setType('group')};
            break;
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        const param = vm.$route.params.id;

        vm.setIsProjectItem(false);

        vm.showLoader();
        await vm.getUsers();
        await vm.getInvitedUsers();
        vm.getOwnedRoles();
        vm.getOwned();
        if (vm.isItemProjects) {
          await vm.getProjectItem(param);
        } else {
          await vm.getProject(param);
        }
        vm.setFullSidebar(false);
        vm.setLinkName('projects');
        let getObj = {}
        const getObjFunc = (inArr) => {
          if (inArr.items.length > 0) {
            inArr.items.forEach((item) => {
              if (vm.$route.params.item == item.id) {
                getObj = item
                return;
              }
              if (item.items.length > 0) {
                getObjFunc(item)
              }
            })
          }
        }
        getObjFunc(vm.projectMother)
        vm.setRouteName(getObj.name);
        document.title = `OmniIoTh | Проект ${vm.projectMother.name}`
        vm.hideLoader()
      })
    }
  }
</script>

<style lang="scss" scoped>
  .project-page {
    padding-bottom: 30px;
    display: flex;
  }

  .project-edit {
    width: 100%;
    padding-left: 70px;
    padding-right: 20px;
    position: relative;
    background: $lightGrey;
  }

  .fullscreen-body {
    background: none;
  }

  .project-body_open {
    padding-left: 300px;

    @media screen and (max-width: 1500px) {
      padding-left: 250px;
    }

    @media screen and (max-width: 1370px) {
      padding-left: 200px;
    }
  }

  .page-padding {
    padding-top: 90px;
  }
</style>
